/* 
DO NOT UPDATE THIS NUMBER
If you need to change the sequence please talk with DevOps as changing this will break the trigger to automatically update version number
*/
export const ADDIN_VERSION = '20261103.1';
